import type { PassFamilyMember } from "@/components/pdf";

type MehmaanRecord = PassFamilyMember & {
  jamaat?: string;
};

export function buildPassMembers(record: {
  familyMembers?: PassFamilyMember[];
  mehmaans?: MehmaanRecord[];
}): PassFamilyMember[] {
  const family = record.familyMembers ?? [];
  const mehmaans = (record.mehmaans ?? []).map((member) => ({
    ...member,
    isMehmaan: true,
  }));
  return [...family, ...mehmaans];
}
